<template>
    <div class="member-detail">
        <bread-crumb :list="[{
            text: '会员',
            url: '/main/member/nav/memberList'
        }, {
            text: '会员详情'
        }]"/>
        <!-- 会员信息 -->
        <up-down v-loading="isLoading" @change="isUp = $event">
            <div slot="down" class="my-down">
                <user-info v-if="memberInfo.user" :userInfo="{
                        avatar: memberInfo.user.avatar,
                        nickname: memberInfo.user.nickname,
                        realname: memberInfo.name,
                        gender: memberInfo.user.gender
                    }" :maxWidth="'500px'"/>
                <base-info :des="'手机'" width="230px" fontSize="16px" :result="get(memberInfo, 'phone')"/>
                <base-info :des="'余额'" width="200px" fontSize="16px" :result="`￥${memberInfo.balance}`"/>
                <base-info :des="'积分'" width="200px" fontSize="16px" :result="`${memberInfo.points}`"/>
                <base-info :des="'会员分组'" :result="memberInfo.group && memberInfo.group.name"/>
            </div>
            <div slot="up" class="my-up">
                <span class="up-left small-avatar avatar-border-style-0" :class="'avatar-border-style-' + (memberInfo.user && memberInfo.user.gender)">
                    <img :src="get(memberInfo, 'user.avatar')" alt="">
                </span>
                <div class="up-right">
                    <p class="name up-right-top">
                        {{ get(memberInfo, 'user.nickname') }}<span v-if="get(memberInfo, 'name') !== ''">（{{ get(memberInfo, 'name') }}）</span>
                    </p>
                    <div class="up-right-mid mt-8">
                        <base-info width="140px" :des="'手机'" :result="get(memberInfo, 'phone')"/>
                        <base-info width="215px" :des="'入会时间'" :result="memberInfo.create_time"/>
                        <base-info width="150px" :result="`￥${memberInfo.balance}`">
                            <span slot="des">余&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;额</span>
                        </base-info>
                        <base-info :des="'积分'" width="150px" :result="`${memberInfo.points}`"/>
                        <base-info width="150px" :des="'消费次数'" :result="memberInfo.accumulated_consume_count"/>
                        <!-- <base-info width="115px" :des="'积分'" :result="''">
                            <question-icon :content="'积分规则：消费1元等于1积分。'" :margin="'0 0 0 8.1px'"/>
                        </base-info> -->
                    </div>
                    <div class="up-right-bottom mt-6">
                        <base-info width="140px" :des="'生日'" :result="memberInfo.birthday"/>
                        <base-info width="215px" :des="'会员编码'" :result="memberInfo.card_code"/>
                        <base-info width="150px" :des="'累计充值'" :result="`￥${memberInfo.accumulated_recharge}`"/>
                        <base-info width="150px" :des="'累计消费'" :result="`￥${memberInfo.accumulated_consume}`"/>
                        <base-info width="150px" :des="'会员分组'" :result="memberInfo.group && memberInfo.group.name"/>
                    </div>
                </div>
            </div>
        </up-down>
        <!-- 余额变动 销售记录 -->
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <el-tab-pane label="余额变动" name="balanceChange"/>
            <el-tab-pane label="积分变动" name="pointsRecord"/>
            <el-tab-pane label="消费记录" name="saleRecord"/>
        </el-tabs>
        <router-view :style="{ height: isUp ? 'calc(100vh - 309px)' : 'calc(100vh - 272px)' }"/>
    </div>
</template>

<script lang="ts">
import BreadCrumb from '@/components/bread_crumb/bread_crumb.vue'
import UpDown from '@/components/up_down/up_down.vue'
import BaseInfo from './modules/base_info.vue'
import QuestionIcon from '@/components/question_icon/question_icon.vue'
import { ref, onBeforeMount } from '@vue/composition-api'
import $fetch from '@/api'
import { openMessage } from '@/utils/system.tsx'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { setObjectItemToFixed } from '../../../utils'
import { routerUtil } from '@/utils/routerUtil'

export default {
    setup(props, ctx) {
        const oRoute = ctx.root.$route
        const query = oRoute.query
        const id: string | Array<string | null> = query.id
        const intId: number = +id
        // reactive data
        const memberInfo = ref({})
        const isUp = ref(false)
        const isLoading = ref(false)

        onBeforeMount(() => {
            getMemberInfo()
        })

        const {
            activeTabName,
            handleTabClick
        } = routerUtil(ctx)

        const getMemberInfo = () => {
            isLoading.value = true
            $fetch.post({
                url: '/membership/getmemberlist',
                params: {
                    member_id: intId
                }
            }).then(data => {
                console.log('会员信息', clone(data))
                memberInfo.value = setObjectItemToFixed(data.member_list[0]) || {}
                isLoading.value = false
            }).catch(e => openMessage('error', e.message || '获取会员信息失败'))
        }

        return {
            // data
            isLoading,
            isUp,
            activeTabName,
            memberInfo,
            // methods
            handleTabClick,
            get
        }
    },
    components: {
        BreadCrumb,
        UpDown,
        BaseInfo,
        QuestionIcon
    }
}
</script>

<style lang="scss" scoped>
::v-deep .base-info {
    margin-left: 40px;
}

.mt-8 {
    margin-top: 8px;
}

.my-down {
    ::v-deep .user-info {
        font-size: 16px;
        font-weight: bolder;

        .small-avatar {
            width: 30px;
            height: 30px;
        }

        .realname {
            color: #666;
            font-weight: normal;
        }
    }
}

.my-up {
    display: flex;
    align-items: center;

    .small-avatar {
        width: 60px;
        height: 60px;
        margin-right: 10px;
    }

    .up-right {
        &-top {
            font-size: 16px;
            color: #333;
            font-weight: bolder;

            span {
                color: #666;
                font-weight: normal;
            }
        }

        &-mid,
        &-bottom {
            display: flex;

            ::v-deep .base-info {
                font-size: 14px;

                &:first-child {
                    margin-left: 0;
                }
            }
        }
    }
}
</style>